<lcs-loading-overlay [show]="callState$ | async | lcsCallState : 'loading'">
  <h2 class="page-title" mat-dialog-title>Call Cost Upload Preview</h2>
  <mat-dialog-content class="mat-dialog-content-no-heading">
    @if (callCosts.length > 0) {
      <div>
        <lcs-responsive-table [columns]="columns">
          <table lcs-table [dataSource]="callCosts">
            <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
            <tr lcs-header-row *lcsResponsiveRowDef></tr>
            <ng-container lcsColumnDef="provider" width="2">
              <th lcs-header-cell *lcsHeaderCellDef id="">Provider</th>
              <td lcs-cell *lcsCellDef="let call">
                {{ call.ProviderId | formatProviders }}
              </td>
            </ng-container>
            <ng-container lcsColumnDef="code" width="1">
              <th lcs-header-cell *lcsHeaderCellDef id="">Code</th>
              <td lcs-cell *lcsCellDef="let call">
                {{ call.Code }}
              </td>
            </ng-container>
            <ng-container lcsColumnDef="destination" width="4">
              <th lcs-header-cell *lcsHeaderCellDef id="">Destination</th>
              <td lcs-cell *lcsCellDef="let call">
                {{ call.Destination }}
              </td>
            </ng-container>
            <ng-container lcsColumnDef="cost" width="2">
              <th lcs-header-cell *lcsHeaderCellDef id="startDate-column-header">Cost</th>
              <td lcs-cell *lcsCellDef="let call"> {{ call.Rate }} </td>
            </ng-container>
          </table>
        </lcs-responsive-table>
      </div>
    } @else {
      <p>Data entered could not be parsed.</p>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    @if (callCosts.length > 0) {
      <button type="button" mat-raised-button color="primary" (click)="onContinue()"
        >Continue With Upload</button
        >
      }
      <button type="button" mat-raised-button color="primary" (click)="onCloseClick()">Close</button>
    </mat-dialog-actions>
  </lcs-loading-overlay>
